// ----------------------------------------------------------------------

export default function IconButton(theme) {
  return {
    MuiIconButton: {
      variants: [],

      styleOverrides: {
        root: {}
      }
    }
  };
}
